export enum AccountPanelStatus {
  Passed = 1,
  Failed = 2,
  Unverified = 3,
  TechnicalError = 4,
  UnsupportedCurrency = 5,
}
